import saveTrack from '../../../utils/gaia/saveTrack';
import {AddSavePromise} from '../../useIsSaved';

// eslint-disable-next-line max-params
export default function update(
    action: UpdateTrackAction,
    tracks: {[trackLocalId: string]: Track},
    setTracks: React.Dispatch<React.SetStateAction<{[trackLocalId: string]: Track}>>,
    project: MapProject,
    addSavePromise: AddSavePromise,
) {

    const {track} = action;
    const {trackLocalId} = track.properties;
    setTracks({
        ...tracks,
        [trackLocalId]: track
    });

    if (action.save === true) saveTrack(track, project, addSavePromise);

    return trackLocalId;
}
